import pjax from 'pjax'

const router = new pjax({
  'elements': 'a:not(.no-pjax)',
  'selectors': ['.js-Pjax', 'title'],
  'switches': {
    '.js-Pjax': pjax.switches.sideBySide
  },
  'switchesOptions': {
    '.js-Pjax': {
      'classNames': {
        'remove': 'animate--fade-out',
        'add': 'animate--fade-in'
      }
    }
  }
})

export default router
